<mg-overlay-primary
  size="auto"
  [overlayTitle]="data?.selectorType === 'assign' ? MESSAGES.MODAL_TITLE_ASSIGN : MESSAGES.MODAL_TITLE_REGISTER"
  [bodyNoPadding]="true">
  <ng-container *ngTemplateOutlet="mainTemplate"></ng-container>
  <ng-template #overlayFooter>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</mg-overlay-primary>

<!-- Main Template -->
<ng-template #mainTemplate>
  <main
    *ngIf="vm$ | async as vm"
    class="modal-form">
    <section class="tw-grid tw-grid-cols-1 tw-gap-3">
      <section class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-column-gap-4 tw-row-gap-3">
        <div
          *ngIf="data.showDatePicker"
          class="filter">
          <mg-form-date
            [minDate]="MIN_DATE"
            [control]="form.controls.date">
          </mg-form-date>
        </div>
        <div
          *ngIf="!data.periodId"
          class="filter">
          <mg-form-select
            [loading]="vm.formState === 'loading'"
            [disabled]="vm.formState === 'loading'"
            [placeholder]="MESSAGES.PERIOD_FILTER_LABEL"
            [floatingLabel]="true"
            [options]="vm.periodOptions"
            [control]="form.controls.periodFilter">
          </mg-form-select>
        </div>
        <div
          *ngIf="!data.teacher"
          class="filter">
          <mg-form-select
            [placeholder]="MESSAGES.TEACHER_FILTER_LABEL"
            [searchable]="true"
            [floatingLabel]="true"
            [isClearable]="true"
            [options]="vm.teacherOptions"
            [control]="form.controls.teacherFilter">
          </mg-form-select>
        </div>
        <div class="filter">
          <mg-form-text-input
            [label]="MESSAGES.TEXT_FILTER_LABEL"
            [isClearable]="true"
            [control]="form.controls.searchFilter">
          </mg-form-text-input>
        </div>
      </section>
      <section class="list">
        <ng-container *ngIf="vm.activePeriodIsPastRegistrationDeadline; else activityList">
          <mg-system-alert
            type="error"
            [message]="MESSAGES.PERIOD_PAST_DEADLINE">
          </mg-system-alert>
        </ng-container>
        <ng-template #activityList>
          <mg-ftm-activity-selector-list
            *ngIf="vm.loadingActivities === false; else activitiesLoader"
            [activities]="vm.filteredActivityInstances"
            [activityCardFields]="CARD_FIELDS"
            [selectedId]="form.controls.flexTimeActivity.value?.id"
            (activitySelected)="setActive($event)">
            <ng-template #noResults>
              <mg-empty-state
                [title]="MESSAGES.EMPTY_STATE_TITLE"
                [subtitle]="MESSAGES.EMPTY_STATE_SUBTITLE_GENERIC">
              </mg-empty-state>
            </ng-template>
          </mg-ftm-activity-selector-list>

          <ng-template #activitiesLoader>
            <div class="tw-flex tw-justify-center tw-items-center">
              <mg-spinner
                [diameter]="40"
                [thickness]="3">
              </mg-spinner>
            </div>
          </ng-template>
        </ng-template>
      </section>
    </section>
  </main>
</ng-template>

<!-- Footer Content Template -->
<ng-template #footerTemplate>
  <footer class="tw-flex tw-justify-between tw-items-center">
    <mg-btn
      variant="text"
      (pressed)="cancel()">
      {{ MESSAGES.CHANGE_CLOSE_BTN }}
    </mg-btn>
    <mg-btn
      variant="filled"
      [disabled]="!(this.form.dirty && this.form.valid)"
      (pressed)="submit()">
      {{ data?.selectorType === 'assign' ? MESSAGES.MODAL_BUTTON_ASSIGN : MESSAGES.MODAL_BUTTON_REGISTER }}
    </mg-btn>
  </footer>
</ng-template>
